var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBriefcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1 1H6.4C4.50982 1 3.56473 1 2.84278 1.36785C2.20773 1.69143 1.69143 2.20773 1.36785 2.84278C1 3.56473 1 4.50982 1 6.4V10V13.6C1 15.4902 1 16.4353 1.36785 17.1572C1.69143 17.7923 2.20773 18.3086 2.84278 18.6321C3.56473 19 4.50982 19 6.4 19H18.1C19.9902 19 20.9353 19 21.6572 18.6321C22.2923 18.3086 22.8086 17.7923 23.1321 17.1572C23.5 16.4353 23.5 15.4902 23.5 13.6V10V6.4C23.5 4.50982 23.5 3.56473 23.1321 2.84278C22.8086 2.20773 22.2923 1.69143 21.6572 1.36785C20.9353 1 19.9902 1 18.1 1Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 10H5.36721C6.13807 10 6.84276 10.4355 7.1875 11.125C7.53224 11.8145 8.23693 12.25 9.00779 12.25H15.4922C16.2631 12.25 16.9678 11.8145 17.3125 11.125C17.6572 10.4355 18.3619 10 19.1328 10H23.5M1 10V6.4C1 4.50982 1 3.56473 1.36785 2.84278C1.69143 2.20773 2.20773 1.69143 2.84278 1.36785C3.56473 1 4.50982 1 6.4 1H18.1C19.9902 1 20.9353 1 21.6572 1.36785C22.2923 1.69143 22.8086 2.20773 23.1321 2.84278C23.5 3.56473 23.5 4.50982 23.5 6.4V10M1 10V13.6C1 15.4902 1 16.4353 1.36785 17.1572C1.69143 17.7923 2.20773 18.3086 2.84278 18.6321C3.56473 19 4.50982 19 6.4 19H18.1C19.9902 19 20.9353 19 21.6572 18.6321C22.2923 18.3086 22.8086 17.7923 23.1321 17.1572C23.5 16.4353 23.5 15.4902 23.5 13.6V10",
    stroke: "#209498",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.53296de903f52d86cece06aaf6c4815a.svg";
export { ForwardRef as ReactComponent };